import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { DIY } from '@/helpers/constants/Store';
import BaseText from '@/components/BaseText.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let TheDiyTerms = class TheDiyTerms extends Mixins(ViewportSizeMixin) {
    submit() {
        this.hideTerms();
    }
    get milestone() {
        const defaultHeaderConfig = {
            align: 'left',
            sortable: false,
        };
        return [
            { text: 'MILESTONES', value: 'milestone', ...defaultHeaderConfig },
            { text: 'RESPONSIBILITY OWNER', value: 'owner', ...defaultHeaderConfig },
            { text: 'DURATION (in days)', value: 'duration', ...defaultHeaderConfig },
        ];
    }
    get responsibility() {
        return [
            {
                milestone: 'Send Onboarding Documentation and Requirements',
                owner: 'GORATED',
                duration: '1d',
            },
            {
                milestone: 'Complete Intake Forms and Other Requirements(Business Registrations if Available)',
                owner: 'CLIENT',
                duration: '6d (from receipt)',
            },
            {
                milestone: 'Submit Completed Requirement & Ensure Approvals from Compliance',
                owner: 'GORATED + CLIENT',
                duration: '3d',
            },
            {
                milestone: 'Onboarding - Session 1 (Set up and Staging)',
                owner: 'GORATED + CLIENT',
                duration: '0.5d',
            },
            {
                milestone: 'Onboarding - Session 1 (Test Transactions - Sales and Transaction Activity Monitoring)',
                owner: 'GORATED + CLIENT',
                duration: '0.5d',
            },
            {
                milestone: 'Onboarding Session 2(Soft Launch - Go Live)',
                owner: 'GORATED + CLIENT',
                duration: '0.5d',
            },
            {
                milestone: 'Onboarding - Session 2 (Employee Training)',
                owner: 'GORATED + CLIENT',
                duration: '0.5d',
            },
            {
                milestone: 'Additional Staff & Employee Training (IF APPLIES)',
                owner: 'GORATED + CLIENT',
                duration: '1d',
            },
            {
                milestone: 'Onboarding Services Acceptance and Turn-over',
                owner: 'GORATED + CLIENT',
                duration: '1d',
            },
            {
                milestone: '',
                owner: 'TOTAL',
                duration: '14 d',
            },
        ];
    }
    get investment() {
        const defaultHeaderConfig = {
            align: 'left',
            sortable: false,
        };
        return [
            { text: '#', value: 'number', ...defaultHeaderConfig },
            { text: 'DESCRIPTION', value: 'description', ...defaultHeaderConfig },
            { text: 'USERS/UNITS', value: 'units', ...defaultHeaderConfig },
            { text: 'TOTAL', value: 'total', ...defaultHeaderConfig },
        ];
    }
    get investmentSubscription() {
        return [
            {
                number: '1',
                description: 'ChatGenie Platform Software Licences',
                units: 'Client Business Account',
                total: 'WAIVED',
            },
            {
                number: '2',
                description: 'Onboarding Fee(Set-up, Onboarding, Testing)',
                units: '1',
                total: 'Included',
            },
            {
                number: '3',
                description: 'User Training (Staff & Employees)',
                units: '1',
                total: 'Included',
            },
            {
                number: '4',
                description: 'POS Hardware Device(s)',
                units: '0',
                total: '0',
            },
            {
                number: '5',
                description: 'Monthly Support/Updates/Maintenance',
                units: '12',
                total: 'Php 25,000 - WAIVED',
            },
            {
                number: '',
                description: '',
                units: 'Subtotal',
                total: 'Php 300,000 - WAIVED',
            },
            {
                number: '',
                description: '',
                units: 'Total Investment',
                total: 'ALL FEES ARE WAIVED WITH FREE TIER PLAN SUBSCRIPTION',
            },
        ];
    }
    get recurringFees() {
        const defaultHeaderConfig = {
            align: 'left',
            sortable: false,
        };
        return [
            { text: 'DESCRIPTION', value: 'description', ...defaultHeaderConfig },
            { text: 'Transaction Fee', value: 'fee', ...defaultHeaderConfig },
            { text: 'Transactions Per Month (TPM)', value: 'tpm', ...defaultHeaderConfig },
            { text: 'Total Billing', value: 'total', ...defaultHeaderConfig },
        ];
    }
    get recurringFeesItems() {
        return [
            {
                description: 'Succesful Transaction',
                fee: '10',
                tpm: '1000',
                total: 'Php 10,000',
            },
            {
                description: '',
                fee: '',
                tpm: 'Total Billing',
                total: 'Php 10,000',
            },
        ];
    }
    get paymentTerms() {
        const defaultHeaderConfig = {
            align: 'left',
            sortable: false,
        };
        return [
            { text: 'Payment Details', value: 'details', ...defaultHeaderConfig },
            { text: 'Amount Due', value: 'amount', ...defaultHeaderConfig },
        ];
    }
    get paymentTermsItems() {
        return [
            {
                details: 'Down Payment (Onboarding Fee) is due immediately after signing(+ VAT, if applicatble)',
                amount: 'Php 25,000 - WAIVED',
            },
            {
                details: 'TOTAL INVESTMENT PAID',
                amount: 'ALL FEES ARE WAIVED WITH FREE TIER PLAN SUBSCRIPTION',
            },
        ];
    }
    get notices() {
        const defaultHeaderConfig = {
            align: 'left',
            sortable: false,
        };
        return [
            { text: 'Notice to CLIENT', value: 'client', ...defaultHeaderConfig },
            { text: 'Notice to GORATED', value: 'gorated', ...defaultHeaderConfig },
        ];
    }
    get noticesItems() {
        return [
            {
                client: '',
                gorated: 'Unit 20, Ipark Center, 401 Amang Rodriguez Ave., Manggahan, Pasig City',
            },
            {
                client: '',
                gorated: 'ragde@gorated.ph',
            },
            {
                client: '',
                gorated: 'Email of your Account/Sales Person',
            },
        ];
    }
};
__decorate([
    Getter('toggleTerms', { namespace: DIY })
], TheDiyTerms.prototype, "toggleTerms", void 0);
__decorate([
    Mutation('hideTerms', { namespace: DIY })
], TheDiyTerms.prototype, "hideTerms", void 0);
TheDiyTerms = __decorate([
    Component({
        components: {
            ActionButton,
            BaseText,
        },
    })
], TheDiyTerms);
export default TheDiyTerms;
